import styled from "styled-components";

export const Conatiner = styled.div`
width: 100%;,
height:100vh;
position:relative;
overflow:hidden;
font-family: Pretendard;
`;
export const Conatiner_title_01 = styled.h1``;

export const Conatiner_1 = styled.div`
  postion: absolute;
`;

export const Pic = styled.img`
  width: 720px;
  position: relative;
  left: 50.7%;
  top: 0px;
`;
export const Pic_02 = styled.img`
  width: 700px;
  position: relative;
  left: 0.1%;
  top: -5px;
`;

export const Conatiner_1_setion = styled.div`
  top: 20%;
  left: 10%;
  position: absolute;
`;

export const Conatiner_text_01 = styled.p`
  text-align: justify;
  postion: relative;
  right: 20%;
`;

export const Conatiner_text_02 = styled.p`
  position: absolute;
  right: 10%;
  top: 65%;
  text-align: center;
  text-align: justify;
`;

export const Conatiner_pre_footer = styled.div``;

export const Conatiner_pre_footer_blocks = styled.div`
  border: 1px solid black;
  padding: 10px;
`;
export const Conatiner_pre_footer_title_01 = styled.h1`
  text-align: center;
  margin-top: 20px;
  font-size: 40px;
  font-weight: 600;
`;
export const Block_links = styled.a`
  padding: 2px;
  width: 100%;
  text-align: center;
  padding: 10px 72px 10px 76.6px;
  text-decoration: none;
  font-size: 14.5px;
  font-weight: 800;
  color: black;
`;

export const Conatiner_footer = styled.div`
  display: flex;
  position: relative;
  left: 60%;
  margin: 20px;
  font-size: 12px;
`;
export const Conatiner_footer_list_title = styled.h1`
  font-size: 20px;
`;
export const Conatiner_footer_list = styled.li`
  list-style: none;
  margin: 20px;
`;
export const Conatiner_footer_list_container = styled.ul``;
export const Bottom_label = styled.label`
  font-size: 12px;
  padding: 10px;
  margin: 10px;
`;

export const Conatiner_Title = styled.h1`
  font-size: 30px;
  font-weight: 500;
  text-align: center;
`;
